import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { DbRestoreJsonPage } from 'pages/db-restore-json/db-restore-json';

@NgModule({
    declarations: [DbRestoreJsonPage],
    imports: [PagesModule, ComponentsModule],
    exports: [DbRestoreJsonPage]
})
export class DbRestoreJsonPageModule {}
